/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    variants: {
        fresh: {
            display: 'inline-flex',
            textStyle: 'descriptor',
            padding: 4,
            backgroundColor: 'lightGreen',
            mb: 2
        },
        fail: {
            display: 'inline-flex',
            textStyle: 'descriptor',
            padding: 4,
            color: 'white',
            backgroundColor: 'burgundy',
            mb: 2
        }
    }
}
